<a class="btnEN" [class.ab-primary]="lang == 'en'" (click)="onLanguageChange('en')">EN</a>
<a class="btnES" [class.ab-primary]="lang == 'es'" (click)="onLanguageChange('es')">ES</a>
